// GLightbox
const lightbox = GLightbox({
	loop: true
});

const lightboxDescription = GLightbox({
	selector: '.glightbox'
});

var minSlides = 4;
var maxSlides = 4;
var sliderMargin = 20;
var slideWidth = 213;

var individualPause = 6000;
var weite = $(window).width();

var newssliderMinSlides = 2;
var newssliderMaxSlides = 2;
var newssliderSlideMargin = 20;
var newsdetailsliderMinSlides = 2;
var newsdetailsliderMaxSlides = 2;
var newsdetailsliderSlideMargin = 20;

// bxslider
var aufgabenfelderNeu = null;
var emotionslider = null;
var pager = true;
var controls = true;
var infiniteLoop = false;

var minSlidesNeu = 5;
var maxSlidesNeu = 5;
var sliderMarginNeu = 12;
var slideWidthNeu = 173;


// randomize function for bxslider
(function($) {
	$.fn.randomize = function(tree, childElem) {
		return this.each(function() {
			var $this = $(this);
			if (tree) $this = $(this).find(tree);
			var unsortedElems = $this.children(childElem);
			var elems = unsortedElems.clone();

			elems.sort(function() { return (Math.round(Math.random())-0.5); });

			for(var i=0; i < elems.length; i++)
				unsortedElems.eq(i).replaceWith(elems[i]);
		});
	};

})(jQuery);

// hide / show first value in an input field onblur and onfocus, if search available
if($('.headersearch-sword').length) {
  var initSearchValue = $('.headersearch-sword').val();
    $('.headersearch-sword').focus(function() {
        var focusValue = $(this).val();
        if(focusValue == initSearchValue) {
            $(this).val("");
        }
    });
    $('.headersearch-sword').blur(function() {
        var blurValue = $(this).val();
        if(blurValue == "") {
            $(this).val(initSearchValue);
        }
    });
}

var showSidebar = function() {
	$('body').removeClass("active-nav").toggleClass("active-sidebar");
	$('.menu-button').removeClass("active-button");
}

var showMenu = function() {
	$('body').removeClass("active-sidebar").toggleClass("active-nav");
	$('.menu-button').toggleClass("active-button");
}

jQuery(window).resize(function(){
	var off_canvas_nav_display = $('.off-canvas-navigation').css('display');
	var menu_button_display = $('.menu-button').css('display');
	if (off_canvas_nav_display === 'block') {
		$("body").removeClass("three-column").addClass("small-screen");
	}
	if (off_canvas_nav_display === 'none') {
		$("body").removeClass("active-sidebar active-nav small-screen")
			.addClass("three-column");
	}
});

$('#mobileMenu').slimmenu({
	resizeWidth: '1200',
	collapserTitle: '',
	animSpeed: 'medium',
	easingEffect: null,
	initiallyVisible: true,
	indentChildren: false,
	childrenIndenter: '&nbsp;'
});

// back to top button
// browser window scroll (in pixels) after which the "back to top" link is shown
var offset = 300,
	//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
	offset_opacity = 1200,
	//duration of the top scrolling animation (in ms)
	scroll_top_duration = 700,
	//grab the "back to top" link
	$back_to_top = $('.cd-top');

//hide or show the "back to top" link
$(window).scroll(function(){
	( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
	if( $(this).scrollTop() > offset_opacity ) {
		$back_to_top.addClass('cd-fade-out');
	}
});

//smooth scroll to top
$back_to_top.on('click', function(e){
	e.preventDefault();
	$('body,html').animate({
			scrollTop: 0 ,
		}, scroll_top_duration
	);
});

// smooth Scroll Functions
// Select all links with hashes
$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.not('.url')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {

				// check if the off-canvas-navigation is displayed
				var off_canvas_nav_display = $('.off-canvas-navigation').css('display');

				// don't scroll if off-canvas-navigation is displayed to prevent the bug caused by the 100% body height in mobile view
				if (off_canvas_nav_display === 'none') {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
					});
				}

			}
		}
	});


$(function smoothscroll() {
	setTimeout(function () {
		if (location.hash) {
			window.scrollTo(0, 0);
			target = location.hash.split('#');
			smoothScrollTo($('#' + target[1]));
		}
	}, 1);

	function smoothScrollTo(target) {
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 100
			}, scroll_top_duration);
		}
	}
});

if (weite > 1100) {
	// ScrollDown
	$('.scrolldown').bind("click", function (event) {
		// Standard Verhalten unterdrücken
		event.preventDefault();
		// Linkziel in Variable schreiben
		var ziel = $(this).attr("href");

		$('html, body').animate({
			//Zum Ziel scrollen (Variable)
			scrollTop: $(ziel).offset().top
			// Dauer der Animation und Callbackfunktion die nach der Animation aufgerufen wird, sie stellt das Standardverhalten wieder her und ergänzt die URL
		}, 500);
	});
}


// emotionimage slider
if ($('.emotionSlider').length > 0 ) {
	// Zufallsreihenfolge Header Slider nur wenn aktiviert im DCE
	if (headerSliderRandom == 1) {
		//$("div.emotionSlider").randomize(".bxslider", "li");
		// bxslider Startseite
		emotionslider = $('.bxslider').bxSlider({
			mode: 'fade',
			speed: 1000,
			auto: true,
			pause: individualPause,
			controls: false,
			randomStart: true,
			onSliderLoad: function(currentIndex) {
				//logViewport();
				//console.log(currentIndex);
				posCaption = parseInt($(".bxslider li:nth-child("+currentIndex+") .caption").css('top'));
				//console.log(posCaption);
				targetIndex = currentIndex + 1;
				myTimeout = setTimeout(function() {
					if (weite > 880) {
						$(".bxslider li:nth-child("+targetIndex+") .caption").css('top', 80);
					}
					if (weite > 1200) {
						$(".bxslider li:nth-child("+targetIndex+") .caption").css('top', 110);
					}
					if (weite > 1500) {
						$(".bxslider li:nth-child("+targetIndex+") .caption").css('top', 140);
					}
					$(".bx-controls").css('top', posCaption-50);
					clearTimeout(myTimeout);
				}, 1500);

			},
			onSlideBefore: function($slideElement, oldIndex, newIndex) {
				//console.log('onSlideBefore');
				//console.log($slideElement);
				//console.log(oldIndex);
				//console.log(newIndex);
				//$($slideElement + '.headertextschraeg').hide();

				actualIndex = newIndex + 1;
				//console.log(actualIndex);

				posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));

				if (newIndex == 3) {
					if ($(".bxslider li:nth-child(4) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(4) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(4) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(4) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(4) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				} else if (newIndex == 2) {
					if ($(".bxslider li:nth-child(3) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(3) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(3) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(3) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(3) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				}
				else if (newIndex == 1) {
					if ($(".bxslider li:nth-child(2) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(2) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(2) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(2) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(2) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				}
				else {
					// console.log('Positin wird gesetzt');
					// $(".bx-controls").css('top', posCaption-40);
					if ($(".bxslider li:nth-child(1) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(1) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(1) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(1) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(1) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				}
			},
		});
	} else {
		// bxslider Startseite
		emotionslider = $('.bxslider').bxSlider({
			mode: 'fade',
			speed: 1000,
			auto: true,
			pause: individualPause,
			controls: false,
			onSliderLoad: function(currentIndex) {
				//logViewport();
			},
			onSlideBefore: function($slideElement, oldIndex, newIndex) {
				//console.log('onSlideAfter');
				//console.log($slideElement);
				//console.log(oldIndex);
				//console.log(newIndex);
				//$($slideElement + '.headertextschraeg').hide();

				actualIndex = newIndex + 1;
				//console.log(actualIndex);

				posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));


				if (newIndex == 2) {
					if ($(".bxslider li:nth-child(3) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(3) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(3) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(3) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(3) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				}
				else if (newIndex == 1) {
					if ($(".bxslider li:nth-child(2) .caption").hasClass('headertextschraeg')) {
						//console.log('headertextschraeg vorhanden');
						if (weite > 880) {
							$(".bxslider li:nth-child(2) .caption").css('top', 80);
						}
						if (weite > 1200) {
							$(".bxslider li:nth-child(2) .caption").css('top', 110);
						}
						if (weite > 1500) {
							$(".bxslider li:nth-child(2) .caption").css('top', 140);
						}
						posCaption = parseInt($(".bxslider li:nth-child("+actualIndex+") .caption").css('top'));
						$(".bx-controls").css('top', posCaption-40);
					} else {
						// wenn keine Schräge
						$(".bxslider li:nth-child(2) .caption").css('top', '40%');
						$(".bx-controls").css('top', 'calc(40% - 40px)');
					}
				}
				else {
					$(".bx-controls").css('top', posCaption-40);
				}
			},

		});
	}
}

// carousel
if ( $('.aufgabenfelderKaruselNeu').length) {

	// randomize carousel only if randomized it's activated in the mask element
	if (karuselRandomNeu == 1) {
		$("div.aufgabenfelderKaruselNeu").randomize(".aufgabenfelderBoxNeu .carousellNeu", "a.slide");
	}

	if (weite > 901) {
		if (($('.aufgabenfelderKaruselNeu .aufgabenfelderBoxNeu .carousellNeu .slide').length < 6)) {
			$('.aufgabenfelderKaruselNeu .aufgabenfelderBoxNeu .bx-pager').hide();
		}
	}


} else {
	$('.aufgabenfelderHinweis').hide();
}

reloadAufgabenfelder();


// responsive carousel
function reloadAufgabenfelder() {
	weite = $(window).width();

	referenzenMinSlides = 1;
	referenzenMaxSlides = 5;
	referenzenSliderWidth = 200;

	if (weite < 901 && weite > 700) {
		minSlides = 3;
		minSlidesNeu = 3;
		maxSlides = 3;
		maxSlidesNeu = 3;
		slideWidth = 600;
		slideWidthNeu = 600;
	} else if (weite < 701 && weite > 480) {
		minSlides = 2;
		minSlidesNeu = 2;
		maxSlides = 2;
		maxSlidesNeu = 2;
		slideWidth = 600;
		slideWidthNeu = 600;
	} else if (weite < 481) {
		minSlides = 1;
		minSlidesNeu = 1;
		maxSlides = 1;
		maxSlidesNeu = 1;
		sliderMargin = 0;
		sliderMarginNeu = 0;
		pager = false;
		controls = false;
		slideWidth = 600;
		slideWidthNeu = 600;
		infiniteLoop = true;
	} else {

	}

	if (weite < 601) {
		newssliderMinSlides = 1;
		newssliderMaxSlides = 1;
		newssliderSlideMargin = 0;
		newsdetailsliderMinSlides = 1;
		newsdetailsliderMaxSlides = 1;
		newsdetailsliderSlideMargin = 0;
		referenzenMinSlides = 1;
		referenzenMaxSlides = 1;
		referenzenSliderWidth = 400;
	}

	// bxslider Carousel
	if ( $(".carousellNeu").length) {
		aufgabenfelderNeu = $('.carousellNeu').bxSlider({
			slideWidth: slideWidthNeu,
			minSlides: minSlidesNeu,
			maxSlides: maxSlidesNeu,
			slideMargin: sliderMarginNeu,
			pager: pager,
			controls: controls,
			infiniteLoop: infiniteLoop,
			hideControlOnEnd: true
		});
	}

	// bxslider Carousel
	if ( $(".carousel2").length) {
		newsslider = $('.carousel2').bxSlider({
			slideWidth: 600,
			minSlides: newssliderMinSlides,
			maxSlides: newssliderMaxSlides,
			slideMargin: newssliderSlideMargin,
			pager: false,
			controls: true,
			infiniteLoop: false,
			hideControlOnEnd: true
		});
	}

	if ( $(".carousel3").length) {
		// bxslider Carousel
		console.log("slider for newsdetails");
		newsdetailslider = $('.carousel3').bxSlider({
			slideWidth: 600,
			minSlides: newsdetailsliderMinSlides,
			maxSlides: newsdetailsliderMaxSlides,
			slideMargin: newsdetailsliderSlideMargin,
			pager: false,
			controls: true,
			infiniteLoop: false,
			hideControlOnEnd: true
		});
	}
}

// accordion
$('.accordion-headline').click(function(e)  {
	if($(this).hasClass('icon-close')){
		//content is closed
		$(this).removeClass('icon-close');
		$(this).addClass('icon-open');
		$(this).closest('.frame').find('.accordion-content').removeClass('hidden');
	} else {
		//content is visibel
		$(this).removeClass('icon-open');
		$(this).addClass('icon-close');
		$(this).closest('.frame').find('.accordion-content').addClass('hidden');
	}
});

// bunte Listenpunkte
$('.content .contentInnerMaxWidth .contentInner .ce-bodytext ul').each(function(el){
	$(this).find('li').addClass('js-li').wrapInner('<span></span>');
});

$('.content .contentInnerFullWidth .contentInner .ce-bodytext ul').each(function(el){
	$(this).find('li').addClass('js-li').wrapInner('<span></span>');
});

// Toggle for nav menu
$('.menu-button').click(function(e) {
	e.preventDefault();
	showMenu();
});
// Toggle for sidebar
$('.sidebar-button').click(function(e) {
	e.preventDefault();
	showSidebar();
});

var $li = $('.subnavigation ul.mainNavi li.firstLine');
var maxHeight = $li.map(function() {
	return $(this).height();
}).get();
$li.height(Math.max.apply(this, maxHeight));

$('.cols2').each(function() {
	$('.downloadBox', this).matchHeight({
		byRow: true
	});
});

$('.cols2').each(function() {
	$('.sameHeightBox', this).matchHeight({
		byRow: true
	});
});


$('.cols4').each(function() {
	$('.linkbox .linkboxHeadline', this).matchHeight({
		byRow: true
	});
});

$('.aufgabenfelderBox .slide .slideHeader', this).matchHeight({
	byRow: true
});

$(window).on('load', function () {
	// Anordnung Bühnen-Headlines zentriert in der Höhe
	if ( $(".emotionSlider").length && !$(".tx-hilfefinder .headerbild .emotionSlider").length) {
		var emotionSliderHeight;
		var emotionSliderMitte;
		emotionSliderHeight = $(".emotionSlider .bx-wrapper .bx-viewport").height();
		emotionSliderCaptionHeight = $('.emotionSlider .bx-wrapper ul li div.caption').height();

		if (emotionSliderHeight != '' && emotionSliderHeight > 0) {
			emotionSliderMitte = emotionSliderHeight/2 - (emotionSliderCaptionHeight/2);
			$('.emotionSlider .bx-wrapper ul li div.caption').css('top', emotionSliderMitte);
			$('.emotionSlider .bx-controls').css('top', emotionSliderMitte-40);
		}
	}

	if ( $(".emotionImage").length) {
		var emotionImageHeight;
		var emotionImageMitte;
		emotionImageHeight = $(".emotionImage").height();
		emotionImageCaptionHeight = $('.emotionImage div.caption').height();

		if (emotionImageHeight != '' && emotionImageHeight > 0) {
			emotionImageMitte = emotionImageHeight/2 - (emotionImageCaptionHeight/2);
			$('.emotionImage div.caption').css('top', emotionImageMitte);
		}
	}

});

// remove last char on location list
if($('.menusubpages__locations').length > 0) {
	$('.menusubpages__locations').each(function() {
		// get the string of the location list
		var locationList = $(this).html().replace(/\s+/g, " ");

		// remove last 2 chars of the text (, and space)
		var strippedLocationList = locationList.slice(0,-2);

		// replace the string
		$(this).html(strippedLocationList);

	});
}

// set equal box height for children
if($('.col-equalboxheight').length > 0) {
	$('.col-equalboxheight').each(function() {
		var maxHeight = 0;
		$(this).find('.frame-custom-200').each(function() {
			if($(this).height() > maxHeight) {
				maxHeight = $(this).height();
			}
		});
		$(this).find('.frame-custom-200').height(maxHeight);
	});
}

